import theme, { createStyles, ThemeColors } from "core/utilities/theme";

export const TABLE_ACTIONS_HEIGHT = 40;

export default createStyles({
  actionBar: {
    width: "100%",
    borderTop: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    background: "white",
    zIndex: 1101,
    height: TABLE_ACTIONS_HEIGHT,
  },
  actions: {
    height: TABLE_ACTIONS_HEIGHT,
    display: "inline-block",
    padding: theme.spacing(0.5, 1),
    borderRight: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
    overflow: "hidden",
    whiteSpace: "nowrap",
    "&::after": {
      position: "absolute",
      right: "0",
      top: "0",
      width: theme.spacing(2),
      height: TABLE_ACTIONS_HEIGHT,
      content: '" "',
      background: `linear-gradient(
        90deg,
        rgba(0,0,0,0) 0%,
        #ffffff 50%,
        #ffffff 100%
      )`,
    },
  },
  actionsWithSelection: {
    backgroundColor: ThemeColors.sequenceAnalyserSelection,
    "&::after": {
      position: "absolute",
      right: "0",
      top: "0",
      width: theme.spacing(2),
      height: TABLE_ACTIONS_HEIGHT,
      content: '" "',
      background: ThemeColors.sequenceAnalyserSelection,
    },
  },
});
